import React, { useCallback } from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';

import IconArrowDropDown from '@material-ui/icons/ArrowDropDown';
import IconProfile from '@material-ui/icons/AccountBox';
import IconLogout from '@material-ui/icons/ExitToApp';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from 'reducers/auth';
import { useTranslation } from 'react-i18next';
import { getFullUserName, getUserImage } from 'reducers/users';
import PropTypes from 'prop-types';
import packageContents from '../../../../package.json';

const HeaderProfile = ({ setViewProfile }) => {
  const { t } = useTranslation();
  // const history = useHistory();
  const classes = useStyles();
  const user = useSelector(state => getFullUserName(state));
  const image = useSelector(state => getUserImage(state));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const handleLogout = useCallback(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const version = `${t('Version')}: ${packageContents?.version}`;
  return (
    <>
      <div className={clsx('headerProfile', classes.headerProfile)}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="Search"
          className={classes.profileButton}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <Avatar
            className={classes.profileAvatar}
            alt={'unknown - user'}
            src={image}
          />
          <span className={classes.profileName}>{user}</span>
          <IconArrowDropDown />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          elevation={1}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          classes={{
            paper: classes.profileMenu,
          }}
        >
          <MenuItem
            onClick={() => {
              setViewProfile(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <IconProfile className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary={t('My Profile')} />
          </MenuItem>

          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <IconLogout className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary={t('Logout')} />
          </MenuItem>
          <Divider />
          <MenuItem>
            <ListItemText primary={version} />
          </MenuItem>
        </Menu>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  headerProfile: {
    display: 'inline-flex',
    color: theme.palette.text.primary,
  },
  profileButton: {
    borderRadius: 30,
    fontSize: '1.2rem',
    padding: 8,
  },
  profileAvatar: {
    width: 35,
    height: 35,
    marginRight: 10,
  },
  profileName: {
    fontWeight: 500,
    marginRight: 5,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  profileMenu: {
    marginLeft: '-16px',
    color: theme.palette.text.primary,
  },
  icon: {
    color: theme.palette.text.primary,
  },
}));
HeaderProfile.propTypes = {
  setViewProfile: PropTypes.func,
};

export default HeaderProfile;
